import { IDeleteFolhaPagamentoUseCase } from "../../../presentation/useCases/delete/delete_folha_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteFolhaPagamentoUseCase
 */

export class DeleteFolhaPagamentoUseCase implements IDeleteFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async deleteFolhaPagamento(
    idFolhaPagamento: number,
  ): Promise<void> {
    await this.repository.deleteFolhaPagamento(idFolhaPagamento);
  }
}
